import React from 'react'
import {
  SpacerVertical,
  Link,
  Typography
} from '@klarna/bubble-ui'

import { interpolateContent } from './utils'

interface LegalLink {
  text: string
  url: string
}

export interface LegalCopy {
  text: string
  link_url: string
  link_text: string
  arial_label_link_text?: string
  additional_links?: LegalLink[]
}

interface LearnMoreLegalProps {
  copy?: LegalCopy
  centered?: boolean
}

function getLink(url: string, text: string) {
  return (
    <Link
      href={url}
      target='_blank'
      rel="noopener noreferrer"
      isUnderlined
      colorToken='colors/text/subtle'
    >
      <Typography textToken='text-style/text/super-paragraphs/tiny/regular'>{text}</Typography>
    </Link>
  )
}

function LearnMoreLegal({ copy }: LearnMoreLegalProps) {
  if (!copy) return null

  const interpolations = {
    terms: getLink(copy.link_url, copy.link_text),
    br: <SpacerVertical spaceToken='space/100'/>
  }

  if (copy.additional_links) {
    for (const key of Object.keys(copy.additional_links)) {
      interpolations[`additional_links_${key}`] = getLink(copy.additional_links[key].url, copy.additional_links[key].text)
    }
  }

  return (
    <>
      <Typography textToken='text-style/text/super-paragraphs/tiny/regular' colorToken='colors/text/neutral'>
        {interpolateContent(copy.text, interpolations)}
      </Typography>
    </>
  )
}

export default LearnMoreLegal
